import React from 'react';
import * as S from './SelectorButton.styles';
import Span from '../Texts/Span/Span';
import Card from '../Card/Card';
import Icon from '../Icon/Icon';
import CuitSelector from '../CuitSelector/CuitSelector';

export const SelectorButton = ({
  onClick,
  selectedQuantity,
  children,
  id,
  bigCommerce,
  cuit,
}) => {
  return bigCommerce ? (
    <CuitSelector cuit={cuit} />
  ) : (
    <Card spacing='6' hasHover>
      <S.SelectorButton onClick={onClick} id={id}>
        <S.Info>
          <S.CountWrapper>
            <Span type='4' variant='neutral' modifier='inverted' weight='bold'>
              {selectedQuantity}
            </Span>
          </S.CountWrapper>
          <S.TextWrapper>
            <Span type='4' variant='neutral' weight='bold'>
              {children}
            </Span>
          </S.TextWrapper>
        </S.Info>
        <Icon name='chevron_right_small' height='24' width='24' />
      </S.SelectorButton>
    </Card>
  );
};
